import React from 'react';
import PropTypes from 'prop-types';

import {
    Box,
    Container,
    Heading,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
} from '@spothero/ui';
import usePrismicInterpolateText from 'hooks/use-prismic-interpolate-text';

const TwoColumnTable = ({tableTitle, columnTitles, tableRows, isMidFunnel}) => {
    const {interpolate} = usePrismicInterpolateText();

    return (
        <Box
            as="section"
            data-testid="TwoColumnTable"
            overflow="clip"
            paddingY={isMidFunnel ? 0 : {base: 8, tablet: 16}}
            marginY={isMidFunnel ? {base: 8, desktop: 12} : 0}
            zIndex="layer1"
        >
            <Container>
                <Heading
                    as="h2"
                    marginBottom={{base: 6, tablet: 8}}
                    textAlign="center"
                >
                    {interpolate(tableTitle)}
                </Heading>
                <Box
                    display="flex"
                    alignContent="center"
                    justifyContent={{base: 'flex-start', desktop: 'center'}}
                    overflowX="auto"
                >
                    <Table variant="rounded" minWidth="420px" marginX={2}>
                        <Thead>
                            <Tr data-testid="TwoColumnTable_column_titles">
                                <Th scope="col">
                                    {interpolate(columnTitles[0])}
                                </Th>
                                <Th scope="col">
                                    {interpolate(columnTitles[1])}
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {tableRows.map((row, i) => (
                                <Tr key={i}>
                                    <Th scope="row" fontSize="base">
                                        {interpolate(row[0])}
                                    </Th>
                                    <Td fontSize="base">
                                        {interpolate(row[1])}
                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                </Box>
            </Container>
        </Box>
    );
};

/* eslint-disable camelcase */
TwoColumnTable.propTypes = {
    tableTitle: PropTypes.string,
    columnTitles: PropTypes.arrayOf(PropTypes.string),
    tableRows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.node)),
    isMidFunnel: PropTypes.bool,
};

export default TwoColumnTable;
